import {createIndexedDbKeyValueStore} from '@Utils/indexed-db-store.util';

const deferredUploadStore = createIndexedDbKeyValueStore('pmwDeferredEditorUploads', 'uploads');

export const storeDeferredEditorUploads = async (posterHashedId: string, files: File[]): Promise<void> => {
  try {
    await deferredUploadStore.put(files, posterHashedId);
  } catch (e) {
    console.error(e);
  }
};

export const getDeferredEditorUploads = async (posterHashedId: string): Promise<File[] | null> => {
  try {
    const files = await deferredUploadStore.get(posterHashedId);
    return Array.isArray(files) ? files.filter((file): file is File => file instanceof File) : null;
  } catch (e) {
    console.error(e);
    return null;
  }
};

export const removeDeferredEditorUploads = async (posterHashedId: string): Promise<void> => {
  try {
    await deferredUploadStore.remove(posterHashedId);
  } catch (e) {
    console.error(e);
  }
};
